var exports = {
  "ag": "xaf9ae18d--63e25b--balloon",
  "Qs": "xaf9ae18d--63e25b--content",
  "Kk": "xaf9ae18d--63e25b--icon",
};

module.exports = exports;
